module.exports = __webpack_public_path__ + "img/activebac.43645876.png";